import {
  Link,
  Outlet,
  useNavigate,
  useLocation,
  useParams,
} from "react-router-dom";

import YoursOpportunityInventoryPage from "./yours_page";

export default function AllPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const params = useParams();

  return (
    <div className="min-h-screen flex flex-col item-start p-4">
      <div>
        <div className="flex flex-row items-center px-4 py-2">
          <Link
            to="yours"
            className={`font-bold px-4 pb-2 ${
              location.pathname === "/opportunity_inventory/yours"
                ? "border-b-4 border-[#F7E21E] text-[#1E293B]"
                : "text-gray-400 font-bold"
            }`}
          >
            Yours
          </Link>
          <Link
            to="all"
            className={`font-bold px-4 pb-2 ${
              location.pathname === "/opportunity_inventory/all"
                ? "border-b-4 border-[#F7E21E] text-[#1E293B]"
                : "text-gray-400 font-bold"
            }`}
          >
            All
          </Link>
        </div>
        <Outlet />
      </div>
    </div>
  );
}
